export type CreateUserErrorCode = 'INVALID_EMAIL' | 'EMAIL_ALREADY_EXISTS' | 'PERMISSION_DENIED' | 'UNKNOWN';

export class CreateUserError extends Error {
    code: CreateUserErrorCode;
    constructor(code: CreateUserErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
